
enum Actions {
    Alert = '@@appointmint/Alert',
    AlertDismiss = '@@appointmint/AlertDismiss',

    LoggingIn = '@@appointmint/LoggingIn',
    LoggedIn = '@@appointmint/LoggedIn',
    LoggedOut = '@@appointmint/LoggedOut',
    LoginFailed = '@@appointmint/LoginFailed',
    SessionUserUpdated = '@@appointmint/SessionUserUpdated',
    SystemNotesCleared = '@@appointmint/SystemNotesCleared',

    UsersLoading = '@@appointmint/UsersLoading',
    UsersLoaded = '@@appointmint/UsersLoaded',
    UserDeleted = '@@appointmint/UserDeleted',
    UserEditing = '@@appointmint/UserEditing',
    UserEditionSubmitting = '@@appointmint/UserEditionSubmitting',
    UserEditionSubmitted = '@@appointmint/UserEditionSubmitted',
    UserEditionSubmitError = '@@appointmint/UserEditionError',
    UserEditionCancel = '@@appointmint/UserEditionCancel',
    UserNewSubmitting = '@@appointmint/UserNewSubmitting',
    UserNewSubmitted = '@@appointmint/UserNewSubmitted',
    UserNewSubmitError = '@@appointmint/UserNewSubmitError',
    
    ClientsLoading = '@@appointmint/ClientsLoading',
    ClientsLoaded = '@@appointmint/ClientsLoaded',
    ClientDeleted = '@@appointmint/ClientDeleted',
    ClientEditing = '@@appointmint/ClientEditing',
    ClientEditionSubmitting = '@@appointmint/ClientEditionSubmitting',
    ClientEditionSubmitted = '@@appointmint/ClientEditionSubmitted',
    ClientEditionSubmitError = '@@appointmint/ClientEditionError',
    ClientEditionCancel = '@@appointmint/ClientEditionCancel',
    ClientNewSubmitting = '@@appointmint/ClientNewSubmitting',
    ClientNewSubmitted = '@@appointmint/ClientNewSubmitted',
    ClientNewSubmitError = '@@appointmint/ClientNewSubmitError',
    
    EntitiesLoading = '@@appointmint/EntitiesLoading',
    EntitiesLoaded = '@@appointmint/EntitiesLoaded',
    EntitiesSearchReset = '@@appointmint/EntitiesSearchReset',
    EntityOpened = '@@appointmint/EntityOpened',
    EntityDeleted = '@@appointmint/EntityDeleted',
    EntityCreating = '@@appointmint/EntityCreating',
    EntityCreatingCancel = '@@appointmint/EntityCreatingCancel',
    EntityEditing = '@@appointmint/EntityEditing',
    EntityEditionSubmitting = '@@appointmint/EntityEditionSubmitting',
    EntityEditionSubmitted = '@@appointmint/EntityEditionSubmitted',
    EntityEditionSubmitError = '@@appointmint/EntityEditionError',
    EntityEditionCancel = '@@appointmint/EntityEditionCancel',
    EntityNewSubmitting = '@@appointmint/EntityNewSubmitting',
    EntityNewSubmitted = '@@appointmint/EntityNewSubmitted',
    EntityNewSubmitError = '@@appointmint/EntityNewSubmitError',
    EntityChangeLogLoading = '@@appointmint/EntityChangeLogLoading',
    EntityChangeLogLoaded = '@@appointmint/EntityChangeLogLoaded',
    EntityChangingUpdate = '@@appointmint/EntityChangingUpdate',

    SetValuesLoaded = '@@appointmint/SetValuesLoaded',

    NotificationsLoaded = '@@appointmint/NotificationsLoaded',
    TasksUpdated = '@@appointmint/TasksUpdated',

    IncomingMessagesSummaryLoaded = '@@appointmint/IncomingMessagesSummaryLoaded',
    IncomingMessageReceived = '@@appointmint/IncomingMessageReceived',
    CommunicationMarkedAsRead = '@@appointmint/CommunicationMarkedAsRead',
    UnreadMessagesMarkedAsRead = '@@appointmint/UnreadMessagesMarkedAsRead',
    CommunicationQuotasLoaded = '@@appointmint/CommunicationQuotasLoaded',

    SelectedBranchChanged = '@@appointmint/SelectedBranchChanged',
    SelectedCashRegisterNameChanged = '@@appointmint/SelectedCashRegisterNameChanged',

    SettingsLoaded = '@@appointmint/SettingsLoaded',
    SettingsUpdated = '@@appointmint/SettingsUpdated',
    InvoiceCatalogLoading = '@@appointmint/InvoiceCatalogLoading',
    InvoiceCatalogLoaded = '@@appointmint/InvoiceCatalogLoaded',
    InvoiceCatalogCleared = '@@appointmint/InvoiceCatalogCleared',
    TaxRatesLoading = '@@appointmint/TaxRatesLoading',
    TaxRatesLoaded = '@@appointmint/TaxRatesLoaded',
    TaxExemptionsLoading = '@@appointmint/TaxExemptionsLoading',
    TaxExemptionsLoaded = '@@appointmint/TaxExemptionsLoaded',
    ReportTemplatesLoading = '@@appointmint/ReportTemplatesLoading',
    ReportTemplatesLoaded = '@@appointmint/ReportTemplatesLoaded',
    ReportTemplateVersionLoaded = '@@appointmint/ReportTemplateVersionLoaded',
    SurveysLoading = '@@appointmint/SurveysLoading',
    SurveysLoaded = '@@appointmint/SurveysLoaded',
    PackTemplatesLoading = '@@appointmint/PackTemplatesLoading',
    PackTemplatesLoaded = '@@appointmint/PackTemplatesLoaded',
    PackTemplateVersionLoaded = '@@appointmint/PackTemplateVersionLoaded',

    ReportTemplateCatalogLoading = '@@appointmint/ReportTemplateCatalogLoading',
    ReportTemplateCatalogLoaded = '@@appointmint/ReportTemplateCatalogLoaded',

    IdentityCardReading = '@@appointmint/IdentityCardReading',
    IdentityCardRead = '@@appointmint/IdentityCardRead',
    IdentityCardError = '@@appointmint/IdentityCardError',

    AiScriberStatusChanged = '@@appointmint/AiScriberStatusChanged',
    AiScriberSessionStarted = '@@appointmint/AiScriberSessionStarted',
    AiScriberTranscriptDeltaReceived = '@@appointmint/AiScriberTranscriptDeltaReceived',
    AiScriberElapsedTick = '@@appointmint/AiScriberElapsedTick',
    AiScriberReset = '@@appointmint/AiScriberReset',
    AiScriberReportDraftReceived = '@@appointmint/AiScriberReportDraftReceived',
}

export default Actions;
